<template>
  <vx-timeline :data="timeline" prefix="view_member.block.timeline.types."></vx-timeline>
</template>

<script>
import moment from 'moment';
import {ResourceImpl} from 'hal-client';
import VxTimeline from '@/components/timeline/VxTimeline';

const acceptedEventTypes = {
  CREATED: {
    icon: 'create',
    iconPack: 'material-icons',
    color: 'warning'
  },
  CREATED_FROM: {
    icon: 'content_copy',
    iconPack: 'material-icons',
    color: 'warning'
  },
  NOTIFICATION_SENT: {
    icon: 'mail',
    iconPack: 'material-icons',
    color: 'warning'
  },
  OPENED: {
    icon: 'drafts',
    iconPack: 'material-icons',
    color: 'primary'
  },
  LINK_CLICKED: {
    icon: 'mouse',
    iconPack: 'material-icons',
    color: 'primary'
  },
  CANCELLED: {
    icon: 'cancel',
    iconPack: 'material-icons',
    color: 'danger'
  },
  ACCEPTED: {
    icon: 'thumb_up',
    iconPack: 'material-icons',
    color: 'success'
  }
};

const eventMapper = (event) => {
  return {
    id: event.id,
    title: event.type,
    desc: moment.utc(moment(event.date)).format('YYYY-MM-DD hh:mm A'), 
    ...acceptedEventTypes[event.type]
  };
};

const eventFilter = (event) => {
  return acceptedEventTypes[event.type] !== undefined;
};

export default {
  name: 'member-timeline',
  components: {VxTimeline},
  props: {
    memberResource: ResourceImpl
  },
  data () {
    return {
      timeline: []
    };
  },
  watch: {
    memberResource: {
      immediate: true,
      deep: true,
      handler (next) {
        next.$request().$get('referral-events').then(res => {
          const newTimeline = !res.$hasEmbedded('referral-events') ? [] : res.$getEmbedded('referral-events').filter(eventFilter).map(eventMapper);

          if (this.memberResource.firstLogged) {
            newTimeline.push({color: 'success',
              desc: moment.utc(moment(this.memberResource.firstLogged)).format('YYYY-MM-DD hh:mm A'),
              icon: 'account_box', 
              iconPack: 'material-icons',
              id: '-1',
              title: 'FIRST_LOGIN'});
          }

          if (this.memberResource.lastActivity) {
            newTimeline.push({color: 'success',
              desc: moment.utc(moment(this.memberResource.lastActivity)).format('YYYY-MM-DD hh:mm A'),
              icon: 'account_box',
              iconPack: 'material-icons',
              id: '-2',
              title: 'LAST_ACTIVITY'});
          }

          this.timeline = newTimeline;

        });
      }
    }
  }
};
</script>

<style scoped>

</style>
